/**
 * Off-canvas main menu (desktop sticky main menu panel)
 */

import $ from 'jquery';
import { getPageId, getActiveMenuItem } from 'components/navigation/active-menu-item.js';

const mainMenuContainer = document.querySelector('#off-canvas-main-menu');
const pageId = getPageId();

if (mainMenuContainer) {
  $(document).on('opened.zf.offCanvas', function() {
    if (!pageId) return;

    const activeMenuItem = getActiveMenuItem(mainMenuContainer, '[data-drilldown]');
    if (!activeMenuItem) return;

    const [activeDrilldown, activeMenu, activeLink] = activeMenuItem;
    if (!activeLink || !activeMenu || !activeDrilldown) return;

    // Set active class on the link
    activeLink.classList.add('is-active');

    // Activate the tab panel containing the active link
    const tabsEl = mainMenuContainer.querySelector('[data-responsive-accordion-tabs], [data-tabs]');
    const tabsPanel = activeLink.closest('.tabs-panel');

    if (tabsEl && tabsPanel) {
      $(tabsEl).foundation('selectTab', $(tabsPanel));
    }

    // Fix Foundation Drilldown height (measured while hidden); trigger resize
    // then navigate to the active submenu once dimensions are correct
    const showActiveMenu = () => {
      $(activeDrilldown).foundation('_showMenu', $(activeMenu), false);

      const activeLinkLi = activeLink.closest('li');
      if (activeLinkLi) {
        const childSubmenu = activeLinkLi.querySelector('ul.menu');
        if (childSubmenu) {
          $(activeDrilldown).foundation('_showMenu', $(childSubmenu), false);
        }
      }
    };

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        $(activeDrilldown).trigger('mutateme.zf.trigger');
        requestAnimationFrame(() => {
          requestAnimationFrame(showActiveMenu);
        });
      });
    });
  });
}
